import { CommonModule, NgClass } from '@angular/common';
import {Component, inject, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {FormControlCollectorDirective} from '../../../directives/form-control-collector.directive';
import {UserFormFactory} from '../../../services/user-form.factory';
import {UserFormErrorComponent} from '../components/user-form-error.component';
import {AutoTabIndexDirective} from '@shared/ui';
import {DropdownModule} from 'primeng/dropdown';
import {UserPreferDateFormatType} from '@core/api/data-access';

@Component({
	selector: 'dc-active-user-preferences',
	styleUrls: ['../user-form.styles.scss'],
	imports: [ReactiveFormsModule, AutoTabIndexDirective, CommonModule, NgClass, FormControlCollectorDirective, TranslateModule, UserFormErrorComponent, DropdownModule],
	styles: ``,
	template: `
		<!-- User Preferences Section Fields -->
		<div class="section-fields-container" [formGroup]="parentForm()" id="user-preferences-section">
			<!-- Date Format -->
			<div class="form-field-container">
				<label for="dateFormat">
					{{ 'user.form.field.dateFormat.title' | translate }}
				</label>
				<p-dropdown
					id="dateFormat"
					formControlName="dateFormat"
					styleClass="w-full"
					dcFormControlCollector
					sectionId="user-preferences"
					[ngClass]="{'error-input': isInvalid('dateFormat')}"
					[placeholder]="'user.form.field.dateFormat.placeholder' | translate"
					[options]="[
						{label: 'user.form.field.dateFormat.european' | translate, value: UserPreferDateFormatType.DDMMYYYY},
						{label: 'user.form.field.dateFormat.american' | translate, value: UserPreferDateFormatType.MMDDYYYY},
					]"
					optionLabel="label"
					optionValue="value"
				/>
				<dc-user-form-error [parentForm]="parentForm()" controlSection="ActiveUserPreferences" controlName="dateFormat" [isInvalidFn]="isInvalid" />
			</div>

			<!-- Days to Reminder -->
			<div class="form-field-container">
				<label for="daysToReminder">
					{{ 'user.form.field.daysToReminder' | translate }}
				</label>
				<input
					id="daysToReminder"
					type="number"
					min="0"
					step="1"
					formControlName="daysToReminder"
					dcFormControlCollector
					sectionId="user-preferences"
					[ngClass]="{'error-input': isInvalid('daysToReminder')}"
					autoTabIndex
				/>
				<dc-user-form-error [parentForm]="parentForm()" controlSection="ActiveUserPreferences" controlName="daysToReminder" [isInvalidFn]="isInvalid" />
			</div>

			<!-- Pen Color -->
			<div class="form-field-container" #penColorContainer>
				<label for="penColor">
					{{ 'user.form.field.penColor' | translate }}
				</label>
				<input id="penColor" type="color" formControlName="penColor" dcFormControlCollector sectionId="user-preferences" [ngClass]="{'error-input': isInvalid('penColor')}" autoTabIndex />
				<dc-user-form-error [parentForm]="parentForm()" controlSection="ActiveUserPreferences" controlName="penColor" [isInvalidFn]="isInvalid" />
			</div>

			<!-- Pen Width -->
			<div class="form-field-container">
				<label for="penWidth">
					{{ 'user.form.field.penWidth' | translate }}
				</label>
				<input
					id="penWidth"
					type="number"
					min="0"
					step="1"
					formControlName="penWidth"
					dcFormControlCollector
					sectionId="user-preferences"
					[ngClass]="{'error-input': isInvalid('penWidth')}"
					autoTabIndex
				/>
				<dc-user-form-error [parentForm]="parentForm()" controlSection="ActiveUserPreferences" controlName="penWidth" [isInvalidFn]="isInvalid" />
			</div>
		</div>
	`,
})
export class ActiveUserPreferencesComponent {
	private readonly userFormFactory = inject(UserFormFactory);
	protected readonly isInvalid = this.userFormFactory.isInvalidFnFactory<'ActiveUserPreferences'>({checkDirty: false});

	readonly parentForm = input.required<FormGroup>();
	protected readonly UserPreferDateFormatType = UserPreferDateFormatType;
}
